<template lang="pug">
.eventshow-completed
  .eventshow-completed-mail
    template(v-if="event.entry.drawing_state === 'result_pending'")
      p
        | ご応募ありがとうございます。
        br
        | 登録してあるメールアドレス宛に、
        br.sp
        | 応募受付完了メールを送信しました。
    template(v-else-if="event.entry.drawing_state === 'unseated'")
      p
        | 残念ながら、ご応募いただいたイベントには落選となりましたことをお知らせいたします。
        br
        | 今後も様々なイベントにご参加いただければ幸いです。
        br.sp
        | 引き続き、どうぞよろしくお願いいたします。
    template(v-else-if="event.entry.drawing_state === 'winning'")
      P
        | 当選いたしました。
        br
        | 当日のご参加をお待ちしております。
      a.v-google-calendar(:href="event.entry.google_calendar_url" target="_blank")
        img(v-lazy="require('~/assets/images/common/google-calendar.png')" width="24" height="24")
        | Googleカレンダーに登録する
    template(v-else)
      p
        | 登録してあるメールアドレス宛に、
        br.sp
        | チケットメールを送信しました。
        br
        | 当日のご参加をお待ちしております。
      a.v-google-calendar(:href="event.entry.google_calendar_url" target="_blank")
        img(v-lazy="require('~/assets/images/common/google-calendar.png')" width="24" height="24")
        | Googleカレンダーに登録する
    table
      tr(v-if="!['unseated', 'winning'].includes(event.entry.drawing_state)")
        th メール送信先
        td
          | {{ $auth.user.email }}
      template(v-if="event.entry.drawing_state === 'winning' || !event.drawing")
        tr
          th チケット番号
          td
            | {{ `#${event.entry.entry_number}` }}
            template(v-if="event.vgt_day2 && event.vgt_day2.entry")
              | {{ `, #${event.vgt_day2.entry.entry_number}` }}
        tr.is-webinar(v-if="event.entry.webinar_url")
          th ウェビナーURL
          td
            a(:href="`${event.entry.webinar_url}`")
              | {{ `${event.entry.webinar_url}` }}
            template(v-if="event.entry.webinar_id")
              br
              | {{ `ウェビナーID：${event.entry.webinar_id}` }}
              br
              | {{ `ウェビナーパスワード：${event.entry.webinar_pw}` }}
  h2
    | イベントに申し込んだことを、みんなに伝えよう！
  .eventshow-completed-sns
    ul
      li
        facebook-button(:url="$route.fullPath" :currentPath="event.detail_url")
      li
        twitter-button(:title="`「${event.name}」に参加します！`" :currentPath="event.detail_url")

  .eventshow-completed-related
    related-packages(v-if="note" :note="note")
    LoglyCardStyleRelatedNotes
</template>

<script>
import FacebookButton from '~/components/social_plugin/FacebookButton'
import TwitterButton from '~/components/social_plugin/TwitterButton'
import RelatedPackages from '~/components/notes/RelatedPackages'
import LoglyCardStyleRelatedNotes from '~/components/LoglyCardStyleRelatedNotes'

export default {
  components: {
    FacebookButton,
    TwitterButton,
    RelatedPackages,
    LoglyCardStyleRelatedNotes
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      note: null
    }
  },
  mounted() {
    if (this.event.note_id) {
      this.$axios.$get(`/notes/${this.event.note_id}`).then((note) => {
        this.note = note
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.eventshow-completed {
  text-align: center;
  padding-top: 20px;
  @include media(sp) {
    padding: 20px 10px 0;
  }
  h2 {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 20px;
  }
  &-sns {
    margin: 0 auto 40px;
    display: table;
    ul {
      display: flex;
    }
    li {
      padding: 0 10px;
    }
    @include media(sp) {
      margin-bottom: 30px;
    }
  }
  &-mail {
    border-bottom: 1px solid #ddd;
    padding-bottom: 40px;
    margin-bottom: 40px;
    p {
      margin-bottom: 20px;
      font-size: 20px;
      font-weight: bold;
      @include media(sp) {
        font-size: 16px;
      }
      strong {
        background: linear-gradient(transparent 60%, rgba($violet, 0.3) 60%);
        font-weight: bold;
      }
    }
    table {
      margin: 20px auto 0;
      font-size: 15px;
      max-width: 500px;
      border-radius: $radius;
      overflow: hidden;
      @include boxshadow($size: 20px, $opacity: 0.2);
      th {
        white-space: nowrap;
        font-weight: bold;
      }
      th,
      td {
        padding: 15px;
        background: #fff;
      }
      tr + tr {
        th,
        td {
          border-top: 2px solid #eee;
        }
      }
      .is-webinar {
        td {
          font-size: 13px;
          line-height: 1.3;
        }
      }
      // word-wrap効かないバグ解消のため下記設定(Zoom URL用)
      a {
        word-break: break-all;
      }
    }
  }
  &-related {
    border-top: 1px solid #dadada;
    text-align: left;
  }
}
</style>
